<template>
  <div data-v-1ee23c10="" class="news-list-container" style="top: 0">
    <ul data-v-1ee23c10="" class="news-list">
      <li data-v-1ee23c10="" id="31234019" v-for="(item, index) in dataList" :key="index" class="news-item" >
        <a @click="$parent.goNav(`/activeInfo?id=${item.id}`)" style="flex: 1">
          <div data-v-1ee23c10="" class="news-item-right">
            <!-- <div data-v-1ee23c10="" class="circle-red"></div> -->
            <div data-v-1ee23c10="" class="news-content-container">
              <h4 data-v-1ee23c10="" class="new-title-wrapper">
                <span data-v-1ee23c10="" class="title">{{ item.activity_name }}</span>
                <span data-v-1ee23c10="" class="time">{{ statuType[item.state] }}</span>
              </h4>
              <p data-v-1ee23c10="" class="news-content">{{ item.created_at }}</p>
            </div>
            <div data-v-1ee23c10="" class="icon-arrow"></div>
          </div>
        </a>
      </li>
      <li style="margin-top:20%" v-if="dataList.length == 0">
        <div style="background: url(/static/img/icon4.99ea03a7.99ea03a.png) no-repeat; background-size: 100% 100%; width: 160px; height: 160px; margin: 0 auto; display: block"></div>
        <p style="text-align: center; ">暂无记录</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'applyagentList',
  data() {
    return { dataList: [], page: 1, statuType: ['0未约定', '待审核', '通过', '拒绝', '4未约定'] };
  },
  created() {
    let that = this;
    that.getData();
  },
  methods: {
    getData() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/activityApplyLog', { page: 1, limit: 999 })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.dataList = res.data.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-099d4415.690b75b1.css';
</style>



// WEBPACK FOOTER //
// src/components/main/applyagentList.vue